<div class="flex flex-row justify-start items-center">
    <div (click)="openPinItem()">{{ name }}</div>
    <app-tb-button [appearance]="'icon'" [icon]="'close'" (click)="removePinItem()">
    </app-tb-button>
</div>
